import React, { PropsWithChildren } from 'react'
import SingleSheet, {
  SingleSheetKey,
  SingleSheetOptions,
  SingleSheetRepository,
} from '../containers/SingleSheet'
import BulkSheet, { BulkSheetOptions } from '../containers/BulkSheet'
import BusinessClients from './BusinessClients'
import { Me, meRepository } from './Me'
import Users from './Users'
import Project from './Project'
import Projects from './Projects'
import Tenant from './Tenant'
import IdProviders from './IdProviders'
import Teams from './Teams'
import Divisions from './Divisions'
import Programs from './Programs'
import TaskActualWork from './TaskActualWork'
import SprintReport from './SprintReport'
import SprintReportNew from './SprintReportNew'
import WorkReport from './WorkReport'
import ProjectApi, {
  projectInformationRepository,
} from '../../lib/functions/project'
import TenantApi from '../../lib/functions/tenant'
import Sprint from './Sprint'
import Positions from './Positions'
import ProjectMember from './ProjectMember/index'
import ProjectPlan from './ProjectPlan'
import OrganizationWorkingDayCalendar from './OrganizationWorkingDayCalendar'
import { Cockpit } from '../../lib/commons/appFunction'
import ResourcePlan from './ResourcePlan'
import ScheduledOperationTime from './ScheduledOperationTime'
import TicketLists from './TicketLists'
import PropertyMaintenance from './PropertyMaintenance'
import ProjectInformationReference from './ProjectInformationReference'
import Report, { ReportOptions } from '../containers/ReportContainer'
import ProgressReportChart from './ProgressReport/Chart'
import ProgressChart from './ProgressChart'
import ChartContainer, { ChartOptions } from '../containers/ChartContainer'
import ProgressReportTable from './ProgressReport/Table'
import ResourceplanNew from './ResourcePlanNew'
import { ProjectOverview } from './ProjectOverview'
import { ProjectPlanNew as ProjectPlanNew } from './ProjectPlanNew'
import ResourcePlanCrossProjects from './ResourcePlanCrossProjects'
import { Box, Fade } from '@mui/material'
import ActualWorkingHours from './ActualWorkingHours'
import {
  TenantExternalServices,
  ProjectExternalServices,
} from './ExternalServices'
import ActualWorkingHoursConfirm from './ActualWorkingHoursConfirm'
import { ProjectReport } from './ProjectReport'
import { EnterpriseProjectReport } from './EnterpriseProjectReport'
import LedgerAccounts from './LedgerAccounts'
import ProfitLossItems from './ProfitLossItems'
import ProfitLossSummary from './ProfitLossSummary'
import MyWbsItems from './MyWbsItems'
import { Tag } from './Tag'
import UnitPricePerPosition from './UnitPricePerPosition'
import ProfitLossMembers from './ProfitLossMembers'
import { styled } from '@mui/system'
import UserPositions from './UserPositions'
import UnitPricePerUsers from './UnitPricePerUsers'
import UnitPricePerProjectPartners from './UnitPricePerProjectPartners'
import { colorPalette } from '../style/colorPalette'
import ProfitLossMembersNew from './ProfitLossMembersNew'
import { BurndownChart } from './BurndownChart'
import { ProjectNotificationSettings } from './ProjectNotificationSettings'
import Kanban from './Kanban'
import KanbanV2 from './KanbanV2'
import { DevelopmentEventWbsItemMapping } from './DevelopmentEventWbsItemStatusMapping'
import { ChatChannelMessageTicketCreationMapping } from './ChatChannelMessageTicketCreationMapping'
import Tickets from './Tickets'
import { WbsItem } from './WbsItem'
import { WbsItemAdditionalProperties } from './WbsAdditionalProperties'
import WbsItemSearch from './WbsItemSearch'
import { ProjectVersionReport } from './ProjectVersionReport'
import { CopyWbs } from './CopyWbs'
import TaskActualWorkApprove from './TaskActualWorkApprove'
import { ProductBacklog } from './ProductBacklog'
import MemberWorkloadStatus from './MemberWorkloadStatus'
import ProjectClosingStatus from './ProjectClosingStatus'
import TicketTypes from './TicketTypes'
import ApiTokenManagement from './ApiTokenManagement'
import UserApiTokens from './UserApiTokens'
import ProjectTaskActualWorkApprovalStatus from './ProjectTaskActualWorkApprovalStatus'
import TaskActualWorkApprovalStatus from './TaskActualWorkApprovalStatus'
import TaskActualWorkProxyRegistration from './TaskActualWorkProxyRegistration'
import TaskActualWorkProxyRequest from './TaskActualWorkProxyRequest'
import { Preferences } from './Preferences'
import { ProjectRules } from './ProjectRules'
import Roles from './Roles'
import PermissionPolicies from './PermissionPolicies'
import { ProgramManagement } from './ProgramManagement'
import { featureFlagService } from '../../utils/feature-flag'
import { projectPrivate } from '../higher-order-components/projectPrivate'
import { ProgramProjectReport } from './ProgramProjectReport'

export enum APPLICATION_FUNCTION_EXTERNAL_ID {
  TENANT_EDIT = 'tenant.edit',
  ID_PROVIDERS = 'idProvider.edit',
  EXTERNAL_SERVICES = 'externalServices.edit',
  DIVISION_EDIT = 'division.edit',
  POSITION_EDIT = 'position.edit',
  ME_EDIT = 'me.edit',
  USER_REGISTRATION = 'user.registration',
  USERS_SEARCH = 'users.search',
  BUSINESSCLIENTS_EDIT = 'businessClients.edit',
  PROJECT_REGISTRATION = 'project.registration',
  PROJECTS_SEARCH = 'projects.search',
  PROJECT_INFORMATION_REFERENCE = 'projectInformation.reference',
  PROJECT_TEAM_EDIT = 'project.team.edit',
  PROJECT_REPORT = 'project.report',
  PROJECT_COCKPIT = 'enterpriseProjectReport.report',
  PROJECT_OVERVIEW = 'project.overview.edit',
  PROJECTPLAN_EDIT = 'projectPlan.edit',
  PROJECTPLAN_NEW_EDIT = 'projectPlan.new.edit',
  PROJECT_SPRINT_EDIT = 'project.sprint.edit',
  PROJECT_MEMBER_EDIT = 'project.member.edit',
  RESOURCE_PLAN_EDIT = 'project.resourcePlan.edit',
  RESOURCE_PLAN_NEW_EDIT = 'project.resourcePlanNew.edit',
  SCHEDULED_OPERATION_TIME = 'project.scheduledOperationTime.edit',
  TASKACTUALWORK_EDIT = 'taskActualWork.edit',
  PROJECT_PROGRESS_REPORT_TABLE = 'project.progressReport.table.reference',
  PROJECT_PROGRESS_REPORT_CHART = 'project.progressReport.chart',
  PROJECT_PROGRESS_CHART = 'project.progressChart',
  PROJECT_SPRINTREPORT = 'project.sprintReport.reference',
  PROJECT_WORKREPORT = 'project.workReport.reference',
  BURNDOWN_CHART = 'project.report.burndownChart',
  ORGANIZATION_WORKING_DAY_CALENDAR_EDIT = 'organizationWorkingDayCalendar.edit',
  WBS_ITEM = 'wbsItem',
  PROCESS = 'process',
  DELIVERABLE_LIST = 'deliverableList',
  DELIVERABLE = 'deliverable',
  TASK = 'task',
  TICKET = 'ticket',
  WBS_ITEM_SEARCH = 'wbsItem.search.edit',
  PROJECT_TAG_EDIT = 'project.tag.edit',
  TICKET_LISTS = 'ticketLists.edit',
  TICKETS = 'ticket.list.edit',
  REFINEMENT_LIST = 'refinement.list.edit',
  ISSUE_LIST = 'issue.list.edit',
  RISK_LIST = 'risk.list.edit',
  CHANGE_REQUEST_LIST = 'changeRequest.list.edit',
  MEETING_LIST = 'meeting.list.edit',
  PROPERTY_MAINTENANCE = 'propertyMaintenance.edit',
  RESOURCE_PLAN_CROSS_PROJECTS_EDIT = 'resourcePlanCrossProjects.edit',
  ACTUAL_WORKING_HOURS_EDIT = 'actualWorkingHours.edit',
  ACTUAL_WORKING_HOURS_CONFIRM = 'actualWorkingHours.confirm',
  TASK_ACTUAL_WORK_APPROVE = 'taskActualWork.approve',
  PROJECT_TASK_ACTUAL_WORK_APPROVAL_STATUS = 'project.taskActualWork.approvalStatus',
  TASK_ACTUAL_WORK_PROXY_REGISTRATION = 'project.proxy.taskActualWork.edit',
  TASK_ACTUAL_WORK_PROXY_REQUEST = 'project.proxy.taskActualWork.request.edit',
  LEDGER_ACCOUNTS = 'ledgerAccounts.edit',
  PROFIT_LOSS_ITEMS_EDIT = 'profitLossItems.edit',
  PROFIT_LOSS_MEMBERS_EDIT = 'profitLossMembers.edit',
  PROFIT_LOSS_MEMBERS_NEW_EDIT = 'profitLossMembers.new.edit',
  PROFIT_LOSS_SUMMARY = 'profitLossSummary.report',
  MY_WBS_ITEMS = 'myWbsItems.edit',
  UNIT_PRICE_PER_POSITION = 'unitPricePerPosition.edit',
  USER_POSITIONS = 'userPositions.edit',
  UNIT_PRICE_PER_USERS = 'unitPricePerUsers.edit',
  UNIT_PRICE_PER_PROJECT_PARTNERS = 'unitPricePerProjectPertners.edit',
  PROJECT_NOTIFICATION_SETTINGS = 'project.notificationSettings.edit',
  KANBAN_STATUS = 'project.kanban.status.edit',
  PROJECT_DEVELOPMENT_EVENT_WBS_ITEM_STATUS_MAPPINGS = 'project.developmentEventWbsItemStatusMapping.edit',
  PROJECT_EXTERNAL_SERVICES = 'project.externalServices.edit',
  PROJECT_CHAT_CHANNEL_MESSAGE_TICKET_CREATION_MAPPINGS = 'project.chatChannelMessageTicketCreationMapping.edit',
  WBS_ITEM_ADDITIONAL_PROPERTIES = 'project.wbsItemAdditionalProperties.edit',
  PROJECT_VERSION_REPORT = 'project.report.versionReport',
  COPY_WBS = 'copyWbs',
  PRODUCT_BACKLOG = 'productBacklog.edit',
  MEMBER_WORKLOAD_STATUS = 'memberWorkload.status',
  PROJECT_CLOSING_STATUS = 'projectClosingStatus.taskActualWork',
  TASK_ACTUAL_WORK_APPROVAL_STATUS = 'taskActualWork.approvalStatus',
  TICKET_TYPES_EDIT = 'project.ticketTypes.edit',
  API_TOKEN_MANAGEMENT_EDIT = 'apiTokenManagement.edit',
  USER_API_TOKEN_EDIT = 'userApiToken.edit',
  PREFERENCES = 'preferences.edit',
  PROJECT_RULES_EDIT = 'project.rules.edit',
  ROLES_EDIT = 'roles.edit',
  PERMISSION_POLICIES_REFERENCE = 'permissionPolicies.reference',
  PROGRAM_LIST = 'programs.edit',
  PROGRAM_MANAGEMENT_EDIT = 'programManagement.edit',
  PROGRAM_PROJECT_REPORT_EDIT = 'programProjectReport.edit',
}

export type PageProps = {
  key: string
  externalId: string
  uuid: string
} & ComponentProps

export interface ComponentProps {
  class: React.ComponentType<any>
  cockpit: Cockpit
  defaultPath: string
  optionalPaths?: string[]
  repository?: SingleSheetRepository
  options?:
    | BulkSheetOptions<any, any, any, any>
    | SingleSheetOptions<any>
    | ReportOptions<any, any, any, any, any, any>
    | ChartOptions<any, any>
  breadcrumbs?: (key: SingleSheetKey) => any
  hideSideMenu?: boolean
  // Overwrite properties(id, options, and repository) to use different ui metas for the same URL
  useUiMetaOf?: (basic: any) => APPLICATION_FUNCTION_EXTERNAL_ID
  // Use alternative function uuid. Set when the same ui state (comment) is shared by multiple components.
  useFunctionUuidOf?: APPLICATION_FUNCTION_EXTERNAL_ID
}

export interface Index {
  [key: string]: ComponentProps
}

// 旧 BulkSheet class 系の画面 (SprintReport feature flag off 時) のための projectPrivate ラッパー。
// 新版に完全移行できたら除去する。
const ProjectPrivateOldBulkSheet = projectPrivate(BulkSheet)

const functions: Index = {
  [APPLICATION_FUNCTION_EXTERNAL_ID.TENANT_EDIT]: {
    class: SingleSheet,
    options: new Tenant(),
    repository: TenantApi,
    cockpit: Cockpit.Tenant,
    defaultPath: '/tenantEdit',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.ID_PROVIDERS]: {
    class: IdProviders,
    cockpit: Cockpit.Tenant,
    defaultPath: '/idProviders',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.EXTERNAL_SERVICES]: {
    class: TenantExternalServices,
    cockpit: Cockpit.Tenant,
    defaultPath: '/externalServices',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.DIVISION_EDIT]: {
    class: Divisions,
    cockpit: Cockpit.Tenant,
    defaultPath: '/divisions',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.POSITION_EDIT]: {
    class: Positions,
    cockpit: Cockpit.Tenant,
    defaultPath: '/positions',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.BUSINESSCLIENTS_EDIT]: {
    class: BusinessClients,
    cockpit: Cockpit.Tenant,
    defaultPath: '/businessClients',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.ME_EDIT]: {
    class: SingleSheet,
    options: new Me(),
    repository: meRepository,
    cockpit: Cockpit.Tenant,
    defaultPath: '/me',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.USERS_SEARCH]: {
    class: Users,
    cockpit: Cockpit.Tenant,
    defaultPath: '/users',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_REGISTRATION]: {
    class: SingleSheet,
    options: new Project(),
    repository: ProjectApi,
    cockpit: Cockpit.Tenant,
    defaultPath: '/projectEdit',
    optionalPaths: ['/projectEdit/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTS_SEARCH]: {
    class: Projects,
    cockpit: Cockpit.Tenant,
    defaultPath: '/projects',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.COPY_WBS]: {
    class: CopyWbs,
    cockpit: Cockpit.Project,
    defaultPath: '/copyWbs',
    optionalPaths: ['/copyWbs/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_INFORMATION_REFERENCE]: {
    class: SingleSheet,
    options: new ProjectInformationReference(),
    repository: projectInformationRepository,
    cockpit: Cockpit.Project,
    defaultPath: '/projectReference',
    optionalPaths: ['/projectReference/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROPERTY_MAINTENANCE]: {
    class: BulkSheet,
    options: new PropertyMaintenance(),
    cockpit: Cockpit.Project,
    defaultPath: '/propertyMaintenance',
    optionalPaths: ['/propertyMaintenance/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_TEAM_EDIT]: {
    class: Teams,
    cockpit: Cockpit.Project,
    defaultPath: '/teams',
    optionalPaths: ['/teams/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_REPORT]: {
    class: ProjectReport,
    cockpit: Cockpit.Project,
    defaultPath: '/projectReport',
    optionalPaths: ['/projectReport/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_COCKPIT]: {
    class: EnterpriseProjectReport,
    cockpit: Cockpit.Project,
    defaultPath: '/enterpriseProjectReport',
    optionalPaths: ['/enterpriseProjectReport/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_OVERVIEW]: {
    class: ProjectOverview,
    cockpit: Cockpit.Project,
    defaultPath: '/projectOverview',
    optionalPaths: ['/projectOverview/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTPLAN_EDIT]: {
    class: ProjectPlan,
    cockpit: Cockpit.Project,
    defaultPath: '/projectPlanOld',
    optionalPaths: ['/projectPlanOld/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTPLAN_NEW_EDIT]: {
    class: ProjectPlanNew,
    cockpit: Cockpit.Project,
    defaultPath: '/projectPlan',
    optionalPaths: ['/projectPlan/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.WBS_ITEM_SEARCH]: {
    class: WbsItemSearch,
    cockpit: Cockpit.Project,
    defaultPath: '/wbsItemSearch',
    optionalPaths: ['/wbsItemSearch/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_SPRINT_EDIT]: {
    class: Sprint,
    cockpit: Cockpit.Project,
    defaultPath: '/sprints',
    optionalPaths: ['/sprints/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_MEMBER_EDIT]: {
    class: ProjectMember,
    cockpit: Cockpit.Project,
    defaultPath: '/members',
    optionalPaths: ['/members/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.RESOURCE_PLAN_EDIT]: {
    class: ResourcePlan,
    cockpit: Cockpit.Project,
    defaultPath: '/resourcePlan',
    optionalPaths: ['/resourcePlan/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.RESOURCE_PLAN_NEW_EDIT]: {
    class: ResourceplanNew,
    cockpit: Cockpit.Project,
    defaultPath: '/resourcePlanNew',
    optionalPaths: ['/resourcePlanNew/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.SCHEDULED_OPERATION_TIME]: {
    class: ScheduledOperationTime,
    cockpit: Cockpit.Project,
    defaultPath: '/workSchedule',
    optionalPaths: ['/workSchedule/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.WBS_ITEM]: {
    class: WbsItem,
    cockpit: Cockpit.Project,
    defaultPath: '/wbsItem',
    optionalPaths: ['/wbsItem/:code'],
    hideSideMenu: true,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.TASKACTUALWORK_EDIT]: {
    class: TaskActualWork,
    cockpit: Cockpit.Project,
    defaultPath: '/actualWork',
    optionalPaths: ['/actualWork/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_PROGRESS_REPORT_TABLE]: {
    class: ProgressReportTable,
    cockpit: Cockpit.Project,
    defaultPath: '/progressReport',
    optionalPaths: ['/progressReport/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_PROGRESS_REPORT_CHART]: {
    class: ChartContainer,
    options: new ProgressReportChart(),
    cockpit: Cockpit.Project,
    defaultPath: '/progressReportChart',
    optionalPaths: ['/progressReportChart/:code'],
    hideSideMenu: true,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_PROGRESS_CHART]: {
    class: Report,
    options: new ProgressChart(),
    cockpit: Cockpit.Project,
    defaultPath: '/progressChart',
    optionalPaths: ['/progressChart/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_SPRINTREPORT]:
    featureFlagService.isEnabled('sprint-report-bulksheet-view')
      ? {
          class: SprintReportNew,
          cockpit: Cockpit.Project,
          defaultPath: '/sprintReport',
          optionalPaths: ['/sprintReport/:code'],
        }
      : {
          class: ProjectPrivateOldBulkSheet,
          options: new SprintReport(),
          cockpit: Cockpit.Project,
          defaultPath: '/sprintReport',
          optionalPaths: ['/sprintReport/:code'],
        },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_WORKREPORT]: {
    class: WorkReport,
    cockpit: Cockpit.Project,
    defaultPath: '/workReport',
    optionalPaths: ['/workReport/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.BURNDOWN_CHART]: {
    class: BurndownChart,
    cockpit: Cockpit.Project,
    defaultPath: '/burndownChart',
    optionalPaths: ['/burndownChart/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_VERSION_REPORT]: {
    class: ProjectVersionReport,
    cockpit: Cockpit.Project,
    defaultPath: '/project/versionReport',
    optionalPaths: ['/project/versionReport/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.ORGANIZATION_WORKING_DAY_CALENDAR_EDIT]: {
    class: OrganizationWorkingDayCalendar,
    cockpit: Cockpit.Tenant,
    defaultPath: '/workingCalender',
  },
  /* Temporary comment out. ref: https://flagxs.sevend.net/wbsItem/LBNQFNEE */
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_TAG_EDIT]: {
    class: Tag,
    cockpit: Cockpit.Project,
    defaultPath: '/tags',
    optionalPaths: ['/tags/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.TICKET]: {
    class: WbsItem,
    cockpit: Cockpit.Project,
    defaultPath: '/ticket',
    optionalPaths: ['/ticket/:code'],
    hideSideMenu: true,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.REFINEMENT_LIST]: {
    class: Tickets,
    cockpit: Cockpit.Project,
    defaultPath: '/tickets',
    optionalPaths: ['/tickets/:code'],
    useUiMetaOf: _ => APPLICATION_FUNCTION_EXTERNAL_ID.TICKETS,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.RISK_LIST]: {
    class: Tickets,
    cockpit: Cockpit.Project,
    defaultPath: '/tickets',
    optionalPaths: ['/tickets/:code'],
    useUiMetaOf: _ => APPLICATION_FUNCTION_EXTERNAL_ID.TICKETS,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.ISSUE_LIST]: {
    class: Tickets,
    cockpit: Cockpit.Project,
    defaultPath: '/tickets',
    optionalPaths: ['/tickets/:code'],
    useUiMetaOf: _ => APPLICATION_FUNCTION_EXTERNAL_ID.TICKETS,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.CHANGE_REQUEST_LIST]: {
    class: Tickets,
    cockpit: Cockpit.Project,
    defaultPath: '/tickets',
    optionalPaths: ['/tickets/:code'],
    useUiMetaOf: _ => APPLICATION_FUNCTION_EXTERNAL_ID.TICKETS,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.MEETING_LIST]: {
    class: Tickets,
    cockpit: Cockpit.Project,
    defaultPath: '/tickets',
    optionalPaths: ['/tickets/:code'],
    useUiMetaOf: _ => APPLICATION_FUNCTION_EXTERNAL_ID.TICKETS,
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.TICKETS]: {
    class: Tickets,
    cockpit: Cockpit.Project,
    defaultPath: '/tickets',
    optionalPaths: ['/tickets/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.TICKET_LISTS]: {
    class: TicketLists,
    cockpit: Cockpit.Project,
    defaultPath: '/ticketLists',
    optionalPaths: ['/ticketLists/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.RESOURCE_PLAN_CROSS_PROJECTS_EDIT]: {
    class: ResourcePlanCrossProjects,
    cockpit: Cockpit.Tenant,
    defaultPath: '/resourcePlanCP',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.ACTUAL_WORKING_HOURS_EDIT]: {
    class: ActualWorkingHours,
    cockpit: Cockpit.Tenant,
    defaultPath: '/actualWorkingHours',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.ACTUAL_WORKING_HOURS_CONFIRM]: {
    class: ActualWorkingHoursConfirm,
    cockpit: Cockpit.Project,
    defaultPath: '/actualWorkingHoursConfirm',
    optionalPaths: ['/actualWorkingHoursConfirm/:code'],
  },
  ...(featureFlagService.isEnabled('task-actual-work-approve')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.TASK_ACTUAL_WORK_APPROVE]: {
          class: TaskActualWorkApprove,
          cockpit: Cockpit.Project,
          defaultPath: '/taskActualWorkApprove',
          optionalPaths: ['/taskActualWorkApprove/:code'],
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('project-task-actual-work-approval-status')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_TASK_ACTUAL_WORK_APPROVAL_STATUS]:
          {
            class: ProjectTaskActualWorkApprovalStatus,
            cockpit: Cockpit.Project,
            defaultPath: '/project/taskActualWorkApprovalStatus',
            optionalPaths: ['/project/taskActualWorkApprovalStatus/:code'],
          },
      }
    : {}),
  ...(featureFlagService.isEnabled('task-actual-work-proxy-registration')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.TASK_ACTUAL_WORK_PROXY_REGISTRATION]:
          {
            class: TaskActualWorkProxyRegistration,
            cockpit: Cockpit.Project,
            defaultPath: '/project/proxy/taskActualWork/registration',
            optionalPaths: ['/project/proxy/taskActualWork/registration/:code'],
          },
      }
    : {}),
  ...(featureFlagService.isEnabled('task-actual-work-approval-status')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.TASK_ACTUAL_WORK_APPROVAL_STATUS]: {
          class: TaskActualWorkApprovalStatus,
          cockpit: Cockpit.Tenant,
          defaultPath: '/taskActualWorkApprovalStatus',
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('task-actual-work-proxy-request')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.TASK_ACTUAL_WORK_PROXY_REQUEST]: {
          class: TaskActualWorkProxyRequest,
          cockpit: Cockpit.Project,
          defaultPath: '/project/proxy/taskActualWork/request',
          optionalPaths: ['/project/proxy/taskActualWork/request/:code'],
        },
      }
    : {}),
  [APPLICATION_FUNCTION_EXTERNAL_ID.LEDGER_ACCOUNTS]: {
    class: LedgerAccounts,
    cockpit: Cockpit.Tenant,
    defaultPath: '/ledgerAccounts',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROFIT_LOSS_ITEMS_EDIT]: {
    class: ProfitLossItems,
    cockpit: Cockpit.Project,
    defaultPath: '/profitLossItems',
    optionalPaths: ['/profitLossItems/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROFIT_LOSS_MEMBERS_EDIT]: {
    class: ProfitLossMembers,
    cockpit: Cockpit.Project,
    defaultPath: '/profitLossMembers',
    optionalPaths: ['/profitLossMembers/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROFIT_LOSS_MEMBERS_NEW_EDIT]: {
    class: ProfitLossMembersNew,
    cockpit: Cockpit.Project,
    defaultPath: '/profitLossMembersNew',
    optionalPaths: ['/profitLossMembersNew/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROFIT_LOSS_SUMMARY]: {
    class: ProfitLossSummary,
    cockpit: Cockpit.Project,
    defaultPath: '/profitLossSummary',
    optionalPaths: ['/profitLossSummary/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.MY_WBS_ITEMS]: {
    class: MyWbsItems,
    cockpit: Cockpit.Tenant,
    defaultPath: '/myTasks',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.UNIT_PRICE_PER_POSITION]: {
    class: UnitPricePerPosition,
    cockpit: Cockpit.Tenant,
    defaultPath: '/unitPrices/positions',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.USER_POSITIONS]: {
    class: UserPositions,
    cockpit: Cockpit.Tenant,
    defaultPath: '/userPositions',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.UNIT_PRICE_PER_USERS]: {
    class: UnitPricePerUsers,
    cockpit: Cockpit.Tenant,
    defaultPath: '/unitPrices/users',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.UNIT_PRICE_PER_PROJECT_PARTNERS]: {
    class: UnitPricePerProjectPartners,
    cockpit: Cockpit.Project,
    defaultPath: '/unitPrices/partners',
    optionalPaths: ['/unitPrices/partners/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_NOTIFICATION_SETTINGS]: {
    class: ProjectNotificationSettings,
    cockpit: Cockpit.Project,
    defaultPath: '/project/notification',
    optionalPaths: ['/project/notification/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.KANBAN_STATUS]: {
    class: featureFlagService.isEnabled('kanban-v2') ? KanbanV2 : Kanban,
    cockpit: Cockpit.Project,
    defaultPath: '/project/kanban',
    optionalPaths: ['/project/kanban/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_DEVELOPMENT_EVENT_WBS_ITEM_STATUS_MAPPINGS]:
    {
      class: DevelopmentEventWbsItemMapping,
      cockpit: Cockpit.Project,
      defaultPath: '/project/developmentEventWbsItemStatusMappings',
      optionalPaths: ['/project/developmentEventWbsItemStatusMappings/:code'],
    },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_EXTERNAL_SERVICES]: {
    class: ProjectExternalServices,
    cockpit: Cockpit.Project,
    defaultPath: '/project/externalServices',
    optionalPaths: ['/project/externalServices/:code'],
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_CHAT_CHANNEL_MESSAGE_TICKET_CREATION_MAPPINGS]:
    {
      class: ChatChannelMessageTicketCreationMapping,
      cockpit: Cockpit.Project,
      defaultPath: '/project/chatChannelMessageTicketCreationMappings',
      optionalPaths: [
        '/project/chatChannelMessageTicketCreationMappings/:code',
      ],
    },
  [APPLICATION_FUNCTION_EXTERNAL_ID.WBS_ITEM_ADDITIONAL_PROPERTIES]: {
    class: WbsItemAdditionalProperties,
    cockpit: Cockpit.Project,
    defaultPath: '/project/wbsItemAdditionalProperties',
    optionalPaths: ['/project/wbsItemAdditionalProperties/:code'],
  },
  ...(featureFlagService.isEnabled('product-backlog')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.PRODUCT_BACKLOG]: {
          class: ProductBacklog,
          cockpit: Cockpit.Project,
          defaultPath: '/productBacklog',
          optionalPaths: ['/productBacklog/:code'],
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('member-workload-status')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.MEMBER_WORKLOAD_STATUS]: {
          class: MemberWorkloadStatus,
          cockpit: Cockpit.Tenant,
          defaultPath: '/memberWorkloadStatus',
          optionalPaths: ['/memberWorkloadStatus/:code'],
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('project-closing-status')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_CLOSING_STATUS]: {
          class: ProjectClosingStatus,
          cockpit: Cockpit.Tenant,
          defaultPath: '/projectClosingStatus/taskActualWork',
        },
      }
    : {}),
  [APPLICATION_FUNCTION_EXTERNAL_ID.TICKET_TYPES_EDIT]: {
    class: TicketTypes,
    cockpit: Cockpit.Project, // Globalから変更してプロジェクト固有に
    defaultPath: '/ticketTypes',
    optionalPaths: ['/ticketTypes/:code'], // プロジェクト識別子対応
  },
  ...(featureFlagService.isEnabled('external-service-api-token')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.API_TOKEN_MANAGEMENT_EDIT]: {
          class: ApiTokenManagement,
          cockpit: Cockpit.Tenant,
          defaultPath: '/apiTokens',
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('user-api-token')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.USER_API_TOKEN_EDIT]: {
          class: UserApiTokens,
          cockpit: Cockpit.Tenant,
          defaultPath: '/userApiTokens',
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('preferences')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.PREFERENCES]: {
          class: Preferences,
          cockpit: Cockpit.Tenant,
          defaultPath: '/preferences',
          hideSideMenu: true,
        },
      }
    : {}),
  ...(featureFlagService.isEnabled('sprints-multi-select')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_RULES_EDIT]: {
          class: ProjectRules,
          cockpit: Cockpit.Project,
          defaultPath: '/project/rules',
          optionalPaths: ['/project/rules/:code'],
        },
      }
    : {}),
  [APPLICATION_FUNCTION_EXTERNAL_ID.ROLES_EDIT]: {
    class: Roles,
    cockpit: Cockpit.Tenant,
    defaultPath: '/roles',
  },
  [APPLICATION_FUNCTION_EXTERNAL_ID.PERMISSION_POLICIES_REFERENCE]: {
    class: PermissionPolicies,
    cockpit: Cockpit.Tenant,
    defaultPath: '/permissionPolicies',
  },
  ...(featureFlagService.isEnabled('program-management')
    ? {
        [APPLICATION_FUNCTION_EXTERNAL_ID.PROGRAM_LIST]: {
          class: Programs,
          cockpit: Cockpit.Tenant,
          defaultPath: '/programs',
        },
        [APPLICATION_FUNCTION_EXTERNAL_ID.PROGRAM_MANAGEMENT_EDIT]: {
          class: ProgramManagement,
          cockpit: Cockpit.Tenant,
          defaultPath: '/programManagement',
          optionalPaths: ['/programManagement/:code'],
        },
        [APPLICATION_FUNCTION_EXTERNAL_ID.PROGRAM_PROJECT_REPORT_EDIT]: {
          class: ProgramProjectReport,
          cockpit: Cockpit.Project,
          defaultPath: '/programProjectReport',
          optionalPaths: ['/programProjectReport/:code'],
        },
      }
    : {}),
}

export default functions

const functionMap = (() => {
  const defaultPathMap = Object.fromEntries(
    Object.entries(functions).map(([key, value]) => [
      value.defaultPath.toLowerCase(),
      { ...value, externalId: key },
    ])
  )
  const optionalPathMap = Object.fromEntries(
    Object.entries(functions).flatMap(([key, value]) =>
      value.optionalPaths
        ? value.optionalPaths.map(path => {
            const parts = path.toLowerCase().split('/')
            const pathWithoutParam = parts
              .filter(p => !p.startsWith(':'))
              .join('')
            return [pathWithoutParam, { ...value, externalId: key }]
          })
        : []
    )
  )
  return { ...defaultPathMap, ...optionalPathMap }
})()

export const getFunctionByPath = (path: string) => {
  let result = functionMap[path.toLowerCase()]
  if (result) {
    return result
  }
  // When the path is "/a/b/<uuid>/<uuid>", the function is for the path "/a/b".
  const parts = path.toLowerCase().split('/')
  for (let i = 0; i < parts.length; i++) {
    result = functionMap[parts.slice(0, -i - 1).join('/')]
    if (result) {
      return result
    }
  }
  return undefined
}

export const getPathByExternalId = (externalId: string) => {
  const appFunction = Object.values(functionMap).find(
    f => f.externalId === externalId
  )
  if (!appFunction) {
    return ''
  }
  return appFunction.defaultPath
}

const PageMain = styled('main')({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
})

export const PageArea = ({ children }: PropsWithChildren<{}>) => (
  <Fade in={true}>
    <Box
      sx={{
        width: '100%',
        height: 'calc(100% - 56px)',
        display: 'flex',
        flexDirection: 'column',
        background: colorPalette.monotone[1],
      }}
    >
      {children}
    </Box>
  </Fade>
)
